<template>
  <div id="ScannedHealth">
    <section class="pet-top">
    <div class="sub-header">
      <button class="back-arrow" @click="goback()">
        <img src="@/assets/svg/menu/chevron-back.svg" />
      </button>
      <h2>Health</h2>
    </div>
  </section>

    <Allergies :editablePage="false" />
    <HealthConditions :editablePage="false" :pet_data="pet_data"/>
    <Medications :editablePage="false" :pet_data="pet_data" />
    <Vaccinations :editablePage="false" :pet_data="pet_data" />

  </div>
</template>

<script>
import {db} from '@/_firebase/init'
import {mapState} from 'vuex'
import Allergies from '@/petprofile/components/pet/tabs/health/Allergies.vue'
// import Microchipped from '@/petprofile/components/pet/tabs/health/Microchipped.vue'
// import MedicalHistory from '@/petprofile/components/pet/tabs/health/MedicalHistory.vue'
import HealthConditions from '@/petprofile/components/pet/tabs/health/HealthConditions.vue'
import Vaccinations from '@/petprofile/components/pet/tabs/health/Vaccinations.vue'
import Medications from '@/petprofile/components/pet/tabs/health/Medications.vue'

export default {
  name: 'ScannedHealth',
  components:{
    Allergies,
    // Microchipped,
    // MedicalHistory,
    HealthConditions,
    Vaccinations,
    Medications
  },
  data(){
    return{
      editablePage: false,
      current_tab: 0,
      processing: false,
      userdata: {},
      pets_owned: [],
      pet_id: this.$route.params.pet_id,
      username: this.$route.params.username,
      pet_data: {photo:'', name: '', allergies:[]},
      sliderStyle:{
        left: '0'
      }
      }
  },
  methods:{
    goback(){
      // this.$router.back()
          window.location.href = `https://app.heybuddy.club/u/${this.username}/pet/${this.pet_id}`;
    },
    setPage(tab){
      this.current_tab = tab
      const base_left = 33
      this.sliderStyle.left = `${base_left*tab}%`
    },
    // async getData(){
    //   const userRef = db.collection('users').doc(this.userID);
    //   const doc = await userRef.get();
    //   if (!doc.exists) {
    //     console.log('No such document!');
    //   } else {
    //     this.userdata = doc.data()
    //     const pet_list = this.userdata.pets_owned
    //     for(let pet_id of pet_list){
    //       this.pets_owned.push(pet_id)
    //       this.getPetData(pet_id)
    //     }
    //   }
    // },
    async getPetData(){
      const petRef = db.collection('pets').doc(this.pet_id);
      const pet_doc = await petRef.get();
      this.pet_data = pet_doc.data()
      this.$store.commit('SET_PETDATA', this.pet_data)
        this.allergy_que = this.pet_data.allergies
      return this.pet_data
    },
  },
  computed:{
    ...mapState([
      'userID'
    ]),
  },
  created(){
    this.getPetData()
  }
}
</script>
<style scoped>
#ScannedHealth{
  margin: auto;
  max-width: 900px;
  background-color: #fff;
  min-height: 90vh;
  padding-bottom: 10rem;
}
.vertical-divider{
  background-color: #adb6e1;
  width: .5px;
  height: 30px;
}
.pet-top{
  background-color: #fff;
  margin-bottom: 2rem;
  -webkit-box-shadow: 0px 35px 41px -48px rgba(135,135,135,1);
  -moz-box-shadow: 0px 35px 41px -48px rgba(135,135,135,1);
  box-shadow: 0px 35px 41px -48px rgba(135,135,135,1);
}
.profile-subnav{
  position: relative;
  width:100%;
  z-index: 10;
  text-align: center;
  display: flex;
  font-family: "Altis";
  justify-content: space-evenly;
  align-items:center;
  background: #fff;
  color: var(--primary);
  font-size: 20px;
  padding: 0 auto;
  text-align: center;
  transition: 1s;
}
.divider{
  width: 3px;
  height: 30px;
  background: #ccc;
}
.profile-subnav  button {
  list-style-type: none;
  width: 100%;
  outline: none;
  background-color: transparent;
  border:none;
  font-weight: bold;
  display: block;
  text-align: center;
  padding: 16px;
  font-size: 12px;
  overflow: hidden;
  display: flex;
  justify-content: space-evenly;
  align-items:center;
  font-family: "Altis";
  cursor: pointer;
  height: 100%;
}
.profile-subnav  button img{
  width: 2.2rem;
  height: 2rem;
}
.profile-subnav  button:hover{
  /* background-color: #bdcdf4; */
  color: var(--primary);
}
#slider {
  background-color:var(--primary);
  position: absolute;
  height: 5px;
  width: 33%;
  bottom: 0;
  left: 0 ;
  transition: .5s;
}
.top-btn .upload-btn{
  width: 3rem;
  height: 3rem;
  position: absolute;
  border-radius: 100%;
  opacity:0;
  top:0;
  left:0;
}
.sub-header{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items:center;
  text-align:center;
  padding: 1rem 0;
  position: relative;
  border-bottom: 1px solid #ddd;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
}
.sub-header h2{
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
  /* or 25px */

  text-align: center;
  letter-spacing: 0.2px;

  /* Greyscale/900 */

  color: #121826;
}
.back-arrow{
  border: none;
  outline:none;
  position: absolute;
  display: flex;
  justify-content:center;
  align-items: center;
  cursor:pointer;
  transition: 1s;
  top: 1rem;
  left: 1.5rem;
  width: 32px;
  height: 32px;
  background: #F7F7FB;
  border-radius: 18px;
}
.menu-title{
  color: var(--primary);
}
.menu-group{
  width: 90%;
  margin: 0 auto;
}
.menu-item-bar{
  width: 90%;
  /* background-color: #f3f3f3; */
  font-size: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: .5rem auto;
  transition: 1s;
  padding: .3rem;
  cursor:pointer;
}
.menu-item-bar:hover{
  transform: translateY(-10px);
}
.setting-icon{
  width: 1.5rem;
  height: 1.5rem;
  padding: .2rem;
  background-color: transparent;
  border-radius: 100%;
  border: 2.5px solid #222;
  transition:1s;
}
.icon-text{
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.icon-text img{
  width: 1.8rem;
  height: 1.8rem;
}
.img-container{
  width: 1.8rem;
  height: 1.8rem;
  padding: .5rem;
  margin-right: 1.5rem;
  background-color: transparent;
  transition:1s;
}
.processing-box{
  bottom: 1rem;
}
.processing-box img{
  width: 3rem;
}
.logout-text{
  color: var(--danger);
}
body[data-theme='dark']  #ScannedHealth{
  background-color: #222;
  color: var(--text-dark);
  border-color: var(--text-dark);
}
body[data-theme='dark']  .menu-item-bar{
  background-color: #555
}
/*mobile base */
@media only screen and (max-width: 600px) {
  .menu-group{
    min-height: 90vh;
    margin-left: 0rem;
  }
  .menu-item-bar{
    width: 100%;
    margin: .8rem auto;
    margin-left: .5rem;
    font-size: .8rem;
  }
  .setting-icon{
    width: 1rem;
    height: 1rem;
  }

}
@media only screen and (max-width: 400px){
  .menu-group{
    margin-left: 0rem;
  }
}
</style>
